var configs = {
    clone: false,
    menu: {
        insertMethod: 'prepend',
        insertSelector: 'body'
    },
    page: {
        nodetype: 'div',
        selector: null,
        noSelector: []
    }
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/offcanvas/_configs.js
// module id = 475
// module chunks = 0